<template>
	<v-container fluid >
		<div class="bottom-buttons-outer">
			<v-btn @click="backClick" color="success">
				<v-icon small>fa-reply</v-icon>&nbsp;{{$t('buttons.back')}}
			</v-btn>
			<v-btn @click="saveClick" color="success">
				<v-icon small>fa-save</v-icon>&nbsp;{{$t('buttons.save')}}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex lg8 md12 pa-1 sm12 xl6 xs12>
				<v-card>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<v-layout row wrap>
									<v-flex xs12>
										<InputField :error="destinationValidation.name"
													:label="'* '+$t('fields.name')"
													v-model="destination.name"></InputField>
									</v-flex>
									<v-flex xs12>
										<InputField :error="destinationValidation.booking_form_link"
													:label="'* '+$t('fields.bookingFormLink')"
													v-model="destination.booking_form_link"></InputField>
									</v-flex>
									<v-flex xs12>
										<InputField :error="destinationValidation.invoice_account_item_en"
													:label="'* '+$t('fields.invoiceAccountItemEn')"
													v-model="destination.invoice_account_item_en"></InputField>
									</v-flex>
									<v-flex xs12>
										<InputField :error="destinationValidation.invoice_account_item_hr"
													:label="'* '+$t('fields.invoiceAccountItemHr')"
													v-model="destination.invoice_account_item_hr"></InputField>
									</v-flex>
									<v-flex xs12>
										<CheckBox
											:label="$t('fields.active')"
											v-model="destination.active"></CheckBox>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import InputField from "./trinkets/InputField";
	import CheckBox from "./trinkets/CheckBox";

	export default {
		name: "TourCategory",
		components: {CheckBox, InputField},
		props: {
			id: Number,
			action: String
		},
		data: function () {
			return {
				initialLoad: false,
				destination: {
					id: this.$route.params.id,
					name: '',
					booking_form_link: '',
					invoice_account_item_en: '',
					invoice_account_item_hr: '',
					active: true
				},
				destinationValidation: {
					id: '',
					name: '',
					booking_form_link: '',
					invoice_account_item_en: '',
					invoice_account_item_hr: '',
					active: ''
				},
				changesHappened: false
			}
		},
		watch: {
			destination: {
				handler: function () {
					if (this.initialLoad) {
						this.changesHappened = true;
					}
				},
				deep: true
			},
		},
		methods: {
			backClick() {
				this.$router.go(-1);
			},
			saveClick() {
				let success = true;

				if (this.destination.name == '') {
					success = false;
					this.destinationValidation.name = this.$t('alerts.fieldError');
				} else {
					this.destinationValidation.name = '';
				}

				if (this.destination.booking_form_link == '') {
					success = false;
					this.destinationValidation.booking_form_link = this.$t('alerts.fieldError');
				} else {
					this.destinationValidation.booking_form_link = '';
				}

				if (this.destination.invoice_account_item_en == '') {
					success = false;
					this.destinationValidation.invoice_account_item_en = this.$t('alerts.fieldError');
				} else {
					this.destinationValidation.invoice_account_item_en = '';
				}

				if (this.destination.invoice_account_item_hr == '') {
					success = false;
					this.destinationValidation.invoice_account_item_hr = this.$t('alerts.fieldError');
				} else {
					this.destinationValidation.invoice_account_item_hr = '';
				}

				if (success) {
					let vm = this;
					let action = 'post';
					let addition = '';
					if (vm.destination.id != 0) {
						action = 'put';
						addition = '/' + vm.destination.id;
					}
					vm.$APICall(action, 'tour-categories' + addition, vm.destination, (data, success) => {
						if (success) {
							vm.changesHappened = false;
							if (vm.destination.id == 0) {
								vm.$notify(vm.$t('alerts.basicAdd'));
							} else {
								vm.$notify(vm.$t('alerts.basicUpdate'));
							}
							vm.$triggerReload();
							vm.backClick();
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			},
		},
		mounted() {
			if (!this.$myStore.state.loggedIn) {
				this.$router.replace('login');
			}
			this.$setSubMenu('Lists');
			if (this.destination.id != 0) {
				let vm = this;
				this.$APICall('get', 'tour-categories/' + this.destination.id, {}, (data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data));
						vm.destination = usableData;
						vm.$myStore.commit('setBreadcrumbs', [
							{text: vm.$t('modules.tourCategories'), href: '/#/tour-categories', disabled: false},
							{text: vm.destination.name, href: '/#/tour-categories/' + vm.destination.id, disabled: true}
						]);
						vm.$nextTick(() => {
							vm.initialLoad = true;
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			} else {
				this.$myStore.commit('setBreadcrumbs', [
					{text: this.$t('modules.tourCategories'), href: '/#/tour-categories', disabled: false},
					{text: this.$t('modules.newTourCategory'), href: '/#/tour-categories/0', disabled: true}
				]);
				this.initialLoad = true;
			}
		},
		beforeRouteLeave(to, from, next) {
			if (this.changesHappened) {
				this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
					next(result);
				});
			} else {
				next(true);
			}
		}
	}
</script>

<style scoped>
</style>
